import { Button } from '@cian/ui-kit';
import { IButtonProps, TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openAutorisationMotivationConsultantCianChat } from 'shared/actions/consultantCianChat/actions';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectUser } from 'shared/selectors/offerData';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { selectTrackingUrl } from 'shared/selectors/offerData/selectTrackingUrl';

import { onEntryAutorisationPopupOpen, onEntryPointClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { SendMessageButton } from '../../../components/SendMessageButton/SendMessageButton';

interface ISendMessageButtonContainerProps {
  title?: string | null;
  ariaLabel?: string;
  size?: IButtonProps['size'];
  theme?: TButtonTheme;
  beforeIcon?: React.JSX.Element;
  noMarginTop?: boolean;
  placeType?: string;
  tabIndex?: number;
}

export const SendMessageButtonContainer = ({
  size = 'M',
  title = 'Написать',
  theme = 'fill_secondary',
  beforeIcon,
  ariaLabel,
  noMarginTop,

  tabIndex,
}: ISendMessageButtonContainerProps) => {
  const { telemetry } = useApplicationContext();
  const { handleOpenChat } = useConsultantCianChat();
  const regionId = useSelector(regionIdSelector);
  const customLabel = useSelector(selectTrackingUrl);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isAuthenticated = user?.isAuthenticated;

  const onClick = React.useCallback(() => {
    onEntryPointClick({ regionId });
    if (!isAuthenticated) {
      onEntryAutorisationPopupOpen({ regionId, customPageURL: customLabel });
      dispatch(openAutorisationMotivationConsultantCianChat());
    } else {
      telemetry.increment('offer_card.send_message_click.newbuilding_consultant');
      handleOpenChat();
    }
  }, [dispatch, handleOpenChat, isAuthenticated, regionId, customLabel]);

  return (
    <SendMessageButton noMarginTop={noMarginTop}>
      <Button
        theme={theme}
        size={size}
        onClick={onClick}
        fullWidth
        beforeIcon={beforeIcon}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
      >
        {title ?? ''}
      </Button>
    </SendMessageButton>
  );
};
